import React from 'react';

const shimmer = {
  background: 'linear-gradient(90deg, #F3F4F6 25%, #E5E7EB 50%, #F3F4F6 75%)',
  backgroundSize: '200% 100%',
  animation: 'shimmer 1.5s infinite',
};

// Add shimmer keyframes via style tag (once)
if (typeof document !== 'undefined' && !document.getElementById('shimmer-style')) {
  const style = document.createElement('style');
  style.id = 'shimmer-style';
  style.textContent = `@keyframes shimmer { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }`;
  document.head.appendChild(style);
}

const Box = ({ width = '100%', height = '16px', radius = '4px', className = '' }) => (
  <div className={className} style={{ width, height, borderRadius: radius, ...shimmer }} />
);

export const ProductCardSkeleton = () => (
  <div className="col-sm-6 col-md-4 col-lg-3">
    <div className="dashboard-card p-0 overflow-hidden">
      <Box height="200px" radius="0" />
      <div className="p-3">
        <Box height="14px" width="40%" className="mb-2" />
        <Box height="18px" width="80%" className="mb-2" />
        <Box height="14px" width="30%" className="mb-3" />
        <Box height="36px" radius="6px" />
      </div>
    </div>
  </div>
);

export const ProductGridSkeleton = ({ count = 8 }) => (
  <div className="row g-4">
    {Array.from({ length: count }).map((_, i) => (
      <ProductCardSkeleton key={i} />
    ))}
  </div>
);

export const ProductDetailSkeleton = () => (
  <div className="section-padding">
    <div className="container">
      <div className="row g-4">
        <div className="col-lg-6">
          <Box height="450px" radius="12px" />
          <div className="d-flex gap-2 mt-3">
            {[1, 2, 3, 4].map((i) => <Box key={i} width="64px" height="64px" radius="8px" />)}
          </div>
        </div>
        <div className="col-lg-6">
          <Box height="14px" width="20%" className="mb-3" />
          <Box height="28px" width="70%" className="mb-2" />
          <Box height="20px" width="25%" className="mb-3" />
          <Box height="14px" width="90%" className="mb-2" />
          <Box height="14px" width="85%" className="mb-2" />
          <Box height="14px" width="60%" className="mb-4" />
          <Box height="48px" radius="8px" className="mb-3" />
          <div className="d-flex gap-2">
            <Box width="48%" height="44px" radius="8px" />
            <Box width="48%" height="44px" radius="8px" />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export const TableSkeleton = ({ rows = 5, cols = 5 }) => (
  <div className="dashboard-card p-0">
    <div className="table-responsive">
      <table className="table mb-0">
        <thead className="table-light">
          <tr>{Array.from({ length: cols }).map((_, i) => <th key={i}><Box height="14px" width={`${50 + Math.random() * 50}%`} /></th>)}</tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, r) => (
            <tr key={r}>
              {Array.from({ length: cols }).map((_, c) => (
                <td key={c}><Box height="14px" width={`${40 + Math.random() * 50}%`} /></td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export const DashboardSkeleton = () => (
  <div>
    <Box height="32px" width="200px" className="mb-4" />
    <div className="row g-3 mb-4">
      {[1, 2, 3, 4].map((i) => (
        <div key={i} className="col-sm-6 col-lg-3">
          <div className="dashboard-card text-center">
            <Box height="26px" width="26px" radius="50%" className="mx-auto mb-2" />
            <Box height="28px" width="50%" className="mx-auto mb-1" />
            <Box height="12px" width="60%" className="mx-auto" />
          </div>
        </div>
      ))}
    </div>
    <TableSkeleton />
  </div>
);

export default {
  ProductCardSkeleton,
  ProductGridSkeleton,
  ProductDetailSkeleton,
  TableSkeleton,
  DashboardSkeleton,
};
